export const BUYER_AUTHORIZATION_INFO = `By confirming buyer authorization, you as the merchant grant the individual identified by the personal
identification number above the right to make purchases on behalf of the specified organization.
It is your responsibility to verify the buyer's identity and ensure that they are legitimately
authorized to act on behalf of the organization.`;
